export enum AutoplayStatusTypes
{
  notAutoplay = 0,
  PaymentSuccessful = 1,
  PaymentProcessing = 2,
  PaymentFailure = 3
}
